<template>
    <div>
        <!-- Begin:PageContent --------------------------------------------- -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin: -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title" v-if="getCurrentLocale ==='de'"><span class="index"><i class="soap-icon-star circle"></i></span>{{ get_InfoalertText_DE.headline }}</h1>
                            <h1 class="idea-title" v-if="getCurrentLocale ==='en'"><span class="index"><i class="soap-icon-star circle"></i></span>{{ get_InfoalertText_EN.headline }}</h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <span class="test" v-html="get_InfoalertText_DE.content" v-if="getCurrentLocale ==='de'" />
                            <span class="test" v-html="get_InfoalertText_EN.content" v-if="getCurrentLocale ==='en'" />
                        </div>
                    </div>
                    <!-- End: -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent ----------------------------------------------- -->


        <!-- Begin:PromoBox ------------------------------------------------ -->
        <sdr-promobox></sdr-promobox>
        <!-- Ebd:PromoBox -------------------------------------------------- -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

	import { query } from 'gql-query-builder';// Graphql


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> --------------------------
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_InfoalertText_DE',
                'get_InfoalertText_EN',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Load 'Covid' Text.
        * Note:
        *
        */
		created: function() {

            let me = this,
				params_DE = null,
				params_EN = null;


            me.$toc('>>> views/cms/infoalert/Home.vue >>> created');
			// >>> ---------------------------------------- Call 'de'
			params_DE = query({
				operation: 'infoalert',
				variables: {
					lang: {
						value : 'de',
						type: 'Lang'
					}
				},
				fields: [
					'_id', 'headline', 'content'
				]
			});
			me.actn_call_getInfoalertText({ payload: params_DE, lang: 'de' });


			// >>> ---------------------------------------- Call 'en'
			params_EN = query({
				operation: 'infoalert',
				variables: {
					lang: {
						value : 'en',
						type: 'Lang'
					}
				},
				fields: [
					'_id', 'headline', 'content'
				]
			});
			me.actn_call_getInfoalertText({ payload: params_EN, lang: 'en' });

		}, // eo function created()

		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_call_getInfoalertText',
			]),

        },
        /* <<< ************************************************************** */

    };
</script>

<style scoped>
    a[target='_blank']:after {
        font-family: 'FontAwesome';
        content: ' \f08e';
    }

    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.6em;
        }
        .booking-information {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>

<style>
    .test ul {
        list-style: square !important;
        margin: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/infos/infoalert/Home.vue